module.exports = __webpack_public_path__ + "img/wrapbg6.ca82a9c8.png";